import { useQuery } from '@tanstack/react-query';
import { OrderDirection } from '../../common/enums/order-direction.enum';
import { getAdminStatistics, getSuperAdminStatistics } from './statistics.api';

export const useSuperAdminStatistics = (
  limit: number,
  page: number,
  search?: string,
  orderBy?: string,
  orderDirection?: OrderDirection,
) => {
  return useQuery({
    queryKey: ['super-admin-statistics', limit, page, search, orderBy, orderDirection],
    queryFn: () => getSuperAdminStatistics(limit, page, search, orderBy, orderDirection),
  });
};

export const useAdminStatistics = (
  limit: number,
  page: number,
  search?: string,
  orderBy?: string,
  orderDirection?: OrderDirection,
) => {
  return useQuery({
    queryKey: ['admin-statistics', limit, page, search, orderBy, orderDirection],
    queryFn: () => getAdminStatistics(limit, page, search, orderBy, orderDirection),
  });
};
